import React from "react";
import "../components/After.scss";

const After = () => {
  return (
    <>
      <div id="after">
        <i className="fas fa-map-marker-alt"></i>
        <div className="after_head">
          <h4>Universacars Areas of Coverage</h4>
        </div>
      </div>
    </>
  );
};

export default After;
